// SYMENTIC SEARCH UI with Fuul text search and doi search



// import React, { useState } from 'react';
// import PropTypes from 'prop-types';
// import { 
//  Button, 
//  Input, 
//  Checkbox,
//  makeStyles, 
//  mergeClasses,
//  Dialog,
//  DialogSurface,
//  DialogTitle,
//  DialogBody,
//  DialogActions,
//  DialogContent,
//  Tooltip // Added Tooltip for explaining the Journal substring logic
// } from '@fluentui/react-components';
// import { ChevronDown20Regular, ChevronUp20Regular, Filter20Regular } from '@fluentui/react-icons';

// const useStyles = makeStyles({
//  container: {
//  padding: '4px 10px',
//  backgroundColor: '#f8f9fa',
//  borderBottom: '1px solid #e0e0e0',
//  },
//  headerWrapper: {
//  display: 'flex',
//  justifyContent: 'space-between',
//  alignItems: 'center',
//  cursor: 'pointer',
//  color: '#022366',
//  fontStyle: 'italic',
//  fontSize: '13px',
//  padding: '4px 0',
//  },
//  headerLeft: {
//  display: 'flex',
//  alignItems: 'center',
//  gap: '8px',
//  },
//  filterIconBtn: {
//  minWidth: 'auto',
//  padding: '2px',
//  color: '#022366',
//  ':hover': {
//  backgroundColor: '#e0e0e0',
//  }
//  },
//  panel: {
//  marginTop: '8px',
//  backgroundColor: '#fff',
//  border: '1px solid #e0e0e0',
//  borderRadius: '4px',
//  overflow: 'hidden',
//  boxShadow: '0 2px 4px rgba(0,0,0,0.05)',
//  display: 'flex',
//  flexDirection: 'column',
//  },
//  tabsContainer: {
//  display: 'flex',
//  borderBottom: '1px solid #022366',
//  backgroundColor: '#f0f0f0',
//  flexShrink: 0,
//  },
//  tab: {
//  padding: '8px 12px',
//  cursor: 'pointer',
//  fontSize: '11px',
//  fontWeight: '600',
//  color: '#333',
//  flex: 1,
//  textAlign: 'center',
//  borderRight: '1px solid #ccc',
//  transition: 'background-color 0.2s',
//  whiteSpace: 'nowrap',
//  overflow: 'hidden',
//  textOverflow: 'ellipsis'
//  },
//  activeTab: {
//  backgroundColor: '#022366',
//  color: '#ffffff',
//  },
  
//  // Full Text Search Row (Pinned at top)
//  searchRow: {
//  display: 'flex',
//  alignItems: 'center',
//  padding: '10px',
//  gap: '8px',
//  backgroundColor: '#f5f5f5',
//  borderBottom: '1px solid #d1d1d1',
//  flexShrink: 0,
//  },
//  searchInput: {
//  flexGrow: 1,
//  backgroundColor: '#ffffff',
//  'input': { fontSize: '12px' }
//  },
//  searchBtn: {
//  backgroundColor: '#022366',
//  color: '#ffffff',
//  fontWeight: '600',
//  fontSize: '12px',
//  padding: '4px 12px',
//  minWidth: 'auto',
//  ':hover': {
//  backgroundColor: '#011640',
//  color: '#ffffff',
//  }
//  },

//  // --- SCROLLABLE AREA ---
//  scrollableFilters: {
//  maxHeight: '220px',
//  overflowY: 'auto',
//  overflowX: 'hidden',
//  backgroundColor: '#ffffff',
//  },

//  // Form Grid Styles
//  formGrid: {
//  display: 'flex',
//  flexDirection: 'column',
//  },
//  formRow: {
//  display: 'flex',
//  borderBottom: '1px solid #e0e0e0',
//  minHeight: '34px',
//  },
//  rowLabel: {
//  width: '125px', 
//  backgroundColor: '#f3f2f1',
//  padding: '6px 8px',
//  display: 'flex',
//  alignItems: 'center',
//  fontSize: '11px',
//  color: '#323130',
//  borderRight: '1px solid #e0e0e0',
//  flexShrink: 0,
//  },
//  rowInputArea: {
//  flex: 1,
//  padding: '4px 8px',
//  display: 'flex',
//  alignItems: 'center',
//  gap: '8px',
//  },
  
//  // Fixed Date Wrapper
//  dateRangeContainer: {
//  display: 'flex',
//  alignItems: 'center',
//  flexWrap: 'wrap',
//  gap: '4px',
//  width: '100%',
//  },
//  compactInput: {
//  flex: 1,
//  minWidth: '100px', 
//  '& input': {
//  fontSize: '11px',
//  padding: '4px 6px'
//  }
//  },
//  dateText: {
//  fontSize: '11px',
//  color: '#605e5c',
//  padding: '0 2px'
//  },

//  // Collapsible Section
//  collapsibleHeader: {
//  width: '100%',
//  backgroundColor: '#f3f2f1',
//  padding: '6px 10px',
//  display: 'flex',
//  justifyContent: 'space-between',
//  alignItems: 'center',
//  cursor: 'pointer',
//  fontSize: '12px',
//  color: '#323130',
//  borderBottom: '1px solid #e0e0e0',
//  },
//  rightsGrid: {
//  display: 'grid',
//  gridTemplateColumns: '1fr 1fr',
//  padding: '8px 12px',
//  backgroundColor: '#faf9f8',
//  borderBottom: '1px solid #e0e0e0',
//  gap: '4px',
//  },
//  checkboxLabel: {
//  '& label': {
//  fontSize: '11px',
//  color: '#323130',
//  }
//  },

//  // Bottom Actions (Pinned at bottom)
//  actionFooter: {
//  display: 'flex',
//  justifyContent: 'flex-end',
//  padding: '10px 12px',
//  gap: '10px',
//  backgroundColor: '#ffffff',
//  borderTop: '1px solid #e0e0e0', 
//  flexShrink: 0,
//  },
//  outlineBtn: {
//  color: '#022366',
//  backgroundColor: '#ffffff',
//  border: '1px solid #022366',
//  fontSize: '12px',
//  padding: '4px 12px',
//  minWidth: 'auto',
//  ':hover': {
//  backgroundColor: '#f3f2f1',
//  color: '#022366',
//  }
//  },
//  dialogCheckboxList: {
//  display: 'grid',
//  gridTemplateColumns: '1fr 1fr',
//  columnGap: '16px',
//  rowGap: '12px',
//  marginTop: '16px',
//  maxHeight: '300px',
//  overflowY: 'auto', 
//  paddingRight: '10px'
//  },
//  dialogSurface: {
//  margin: '16px',
//  minWidth: 'auto',
//  maxWidth: 'calc(100vw - 32px)', 
//  padding: '8px'
//  },
//  doiErrorText: {
//   color: '#d13438',
//   fontSize: '11px',
//   padding: '4px 10px',
//   backgroundColor: '#fde7e9',
//   borderBottom: '1px solid #d1d1d1'
//  }
// });

// const RomineFilter = ({ onApply }) => {
//  const styles = useStyles();
//  const [isExpanded, setIsExpanded] = useState(false);
//  const [activeTab, setActiveTab] = useState('semantic');
//  const [isRightsExpanded, setIsRightsExpanded] = useState(true);

//  // --- Visibility State for Filters ---
//  const initialVisibility = {
//  fullText: true,
//  pubDate: true,
//  sourceTitle: true,
//  dataProvider: true,
//  rights: true,
//  createdAt: true,
//  volume: false,
//  issue: false,
//  lastRecordUpdate: false,
//  limit: false,
//  issn: false,
//  };
//  const [filterVisibility, setFilterVisibility] = useState(initialVisibility);
  
//  // --- Modal State ---
//  const [isFilterModalOpen, setIsFilterModalOpen] = useState(false);
//  const [tempVisibility, setTempVisibility] = useState(initialVisibility);

//  // --- Form Data State ---
//  // Tab 0: Semantic Search States
//  const [semanticSearch, setSemanticSearch] = useState('');
//  const [semanticDataProvider, setSemanticDataProvider] = useState('');
//  const [semanticJournal, setSemanticJournal] = useState(''); // Added Journal state

//  // Tab 1: Articles States
//  const [fullTextSearch, setFullTextSearch] = useState('');
//  const [doiSearch, setDoiSearch] = useState('');
//  const [pubStartDate, setPubStartDate] = useState('');
//  const [pubEndDate, setPubEndDate] = useState('');
//  const [sourceTitle, setSourceTitle] = useState('');
//  const [dataProvider, setDataProvider] = useState('');
//  const [rights, setRights] = useState({
//  perpetualAccess: false,
//  aiTraining: false,
//  aiInference: false,
//  aiMedinfo: false
//  });
//  const [createdStartDate, setCreatedStartDate] = useState('');
//  const [createdEndDate, setCreatedEndDate] = useState('');
//  const [volume, setVolume] = useState('');
//  const [issue, setIssue] = useState('');
//  const [lastRecordUpdateStart, setLastRecordUpdateStart] = useState('');
//  const [lastRecordUpdateEnd, setLastRecordUpdateEnd] = useState('');
//  const [limit, setLimit] = useState(''); 
//  const [issn, setIssn] = useState('');

//  const toggleExpand = () => setIsExpanded(!isExpanded);
//  const toggleRights = () => setIsRightsExpanded(!isRightsExpanded);

//  const handleReset = () => {
//  // Reset Semantic Search Fields
//  setSemanticSearch('');
//  setSemanticDataProvider('');
//  setSemanticJournal(''); // Cleaned up publication date resets to support Journal

//  // Reset Articles Fields
//  setFullTextSearch('');
//  setDoiSearch('');
//  setPubStartDate('');
//  setPubEndDate('');
//  setSourceTitle('');
//  setDataProvider('');
//  setRights({
//  perpetualAccess: false,
//  aiTraining: false,
//  aiInference: false,
//  aiMedinfo: false
//  });
//  setCreatedStartDate('');
//  setCreatedEndDate('');
//  setVolume('');
//  setIssue('');
//  setLastRecordUpdateStart('');
//  setLastRecordUpdateEnd('');
//  setLimit('');
//  setIssn('');
//  };

//  // Calculate current DOI count by splitting by commas and ignoring empty spaces
//  const currentDoiCount = doiSearch.split(',').map(d => d.trim()).filter(d => d.length > 0).length;
//  const isDoiLimitExceeded = currentDoiCount > 20;
//  const excessDoiCount = currentDoiCount - 20;

//  const handleApply = () => {
//  if (!onApply) return;

//  if (activeTab === 'semantic') {
//   onApply({
//    filterType: 'semantic',
//    query: semanticSearch,
//    filters: {
//     dataProvider: semanticDataProvider,
//     journal: semanticJournal // Passes the mapped Journal filter text to backend query
//    }
//   });
//  } else if (activeTab === 'articles') {
//   const appliedFilters = {};
  
//   if (filterVisibility.pubDate) {
//    appliedFilters.pubStartDate = pubStartDate;
//    appliedFilters.pubEndDate = pubEndDate;
//   }
//   if (filterVisibility.sourceTitle) appliedFilters.sourceTitle = sourceTitle;
//   if (filterVisibility.dataProvider) appliedFilters.dataProvider = dataProvider;
//   if (filterVisibility.rights) appliedFilters.rights = rights;
//   if (filterVisibility.createdAt) {
//    appliedFilters.createdStartDate = createdStartDate;
//    appliedFilters.createdEndDate = createdEndDate;
//   }
//   if (filterVisibility.volume) appliedFilters.volume = volume;
//   if (filterVisibility.issue) appliedFilters.issue = issue;
//   if (filterVisibility.issn) appliedFilters.issn = issn;
//   if (filterVisibility.limit) appliedFilters.limit = limit ? parseInt(limit, 10) : null;
//   if (filterVisibility.lastRecordUpdate) {
//    appliedFilters.lastRecordUpdateStart = lastRecordUpdateStart;
//    appliedFilters.lastRecordUpdateEnd = lastRecordUpdateEnd;
//   }

//   onApply({
//    filterType: 'articles',
//    query: filterVisibility.fullText ? fullTextSearch : '',
//    filters: appliedFilters
//   });
//  } else {
//   // Prevent submission if DOI limit is exceeded (fallback security)
//   if (isDoiLimitExceeded) return; 

//   onApply({
//    filterType: 'doi',
//    query: doiSearch
//   });
//  }
  
//  setIsExpanded(false); 
//  };

//  const handleRightChange = (key, checked) => {
//  setRights(prev => ({ ...prev, [key]: checked }));
//  };

//  const openFilterModal = (e) => {
//  e.stopPropagation(); 
//  setTempVisibility(filterVisibility);
//  setIsFilterModalOpen(true);
//  };

//  const saveFilterVisibility = () => {
//  setFilterVisibility(tempVisibility);
//  setIsFilterModalOpen(false);
//  setIsExpanded(true); 
//  };

//  return (
//  <div className={styles.container}>
//  <div className={styles.headerWrapper} onClick={toggleExpand}>
//  <div className={styles.headerLeft}>
//   <span>Choose and apply filters</span>
//   <Button
//   appearance="transparent"
//   icon={<Filter20Regular />}
//   className={styles.filterIconBtn}
//   onClick={openFilterModal}
//   title="Select visible filters"
//   />
//  </div>
//  {isExpanded ? <ChevronUp20Regular /> : <ChevronDown20Regular />}
//  </div>

//  {isExpanded && (
//  <div className={styles.panel}>
   
//   {/* Tabs Header */}
//   <div className={styles.tabsContainer}>
//   <div 
//   className={mergeClasses(styles.tab, activeTab === 'semantic' && styles.activeTab)}
//   onClick={() => setActiveTab('semantic')}
//   >
//   Semantic Search
//   </div>
//   <div 
//   className={mergeClasses(styles.tab, activeTab === 'articles' && styles.activeTab)}
//   onClick={() => setActiveTab('articles')}
//   >
//   Articles By Filters & Full Text Search
//   </div>
//   <div 
//   className={mergeClasses(styles.tab, activeTab === 'doi' && styles.activeTab)}
//   onClick={() => setActiveTab('doi')}
//   >
//   Select DOI
//   </div>
//   </div>

//   {/* ----------------- TAB 0: SEMANTIC SEARCH ----------------- */}
//   {activeTab === 'semantic' && (
//   <>
//   {/* 1. QUERY BOX */}
//   <div className={styles.searchRow}>
//    <Input 
//    className={styles.searchInput}
//    placeholder="Semantic query search here..." 
//    value={semanticSearch}
//    onChange={(e, data) => setSemanticSearch(data.value)}
//    />
//    <Button className={styles.searchBtn} onClick={handleApply}>
//    Semantic Search
//    </Button>
//   </div>

//   {/* 2. SEMANTIC SEARCH FILTERS */}
//   <div className={styles.scrollableFilters}>
//   <div className={styles.formGrid}>

//     {/* Data Provider Field */}
//    <div className={styles.formRow}>
//        <div className={styles.rowLabel}>Data Provider</div>
//        <div className={styles.rowInputArea}>
//        <Input 
//         className={styles.compactInput} 
//         placeholder="Type here...eg. Ovid (ASCO), etc" 
//         value={semanticDataProvider}
//         onChange={(e, data) => setSemanticDataProvider(data.value)}
//        />
//        </div>
//    </div>
    
//    {/* Journal Field (Replacing Date Range with Substring guidelines) */}
//    <div className={styles.formRow}>
//    <div className={styles.rowLabel}>Journal</div>
//    <div className={styles.rowInputArea}>
//     <Tooltip 
//      content={
//       <div style={{ padding: '4px', maxWidth: '280px', fontSize: '11px', lineHeight: '1.4' }}>
//        <strong>Exact Match:</strong> Type exact journal name (e.g., <em>Diagnostics</em>)<br />
//        <strong>Substring Match:</strong> Prefix with <strong>~</strong> (e.g., <em>~nature</em> matches "Nature", "Nature Genetics", etc.)<br />
//        <em>* Case-insensitive</em>
//       </div>
//      }
//      relationship="description"
//     >
//      <Input 
//       className={styles.compactInput} 
//       placeholder='e.g., Diagnostics, ~nature, ~lancet, ~nat' 
//       value={semanticJournal}
//       onChange={(e, data) => setSemanticJournal(data.value)}
//      />
//     </Tooltip>
//    </div>
//    </div>

//   </div>
//   </div>
   
//   {/* 3. PINNED ACTIONS */}
//   <div className={styles.actionFooter}>
//   <Button className={styles.outlineBtn} onClick={handleReset}>
//    Reset fields
//   </Button>
//   <Button className={styles.outlineBtn} onClick={handleApply}>
//    Apply filters
//   </Button>
//   </div>
//   </>
//   )}

//   {/* ----------------- TAB 1: ARTICLES ----------------- */}
//   {activeTab === 'articles' && (
//   <>
//   {/* 1. PINNED FULL TEXT SEARCH */}
//   {filterVisibility.fullText && (
//   <div className={styles.searchRow}>
//    <Input 
//    className={styles.searchInput}
//    placeholder="Full text search here.." 
//    value={fullTextSearch}
//    onChange={(e, data) => setFullTextSearch(data.value)}
//    />
//    <Button className={styles.searchBtn} onClick={handleApply}>
//    Full Text Search
//    </Button>
//   </div>
//   )}

//   {/* 2. SCROLLABLE FILTERS LIST */}
//   <div className={styles.scrollableFilters}>
//   <div className={styles.formGrid}>
    
//    {filterVisibility.pubDate && (
//    <div className={styles.formRow}>
//    <div className={styles.rowLabel}>Publication Date</div>
//    <div className={styles.rowInputArea}>
//    <div className={styles.dateRangeContainer}>
//     <Input 
//     type="date" 
//     className={styles.compactInput} 
//     value={pubStartDate}
//     onChange={(e, data) => setPubStartDate(data.value)}
//     />
//     <span className={styles.dateText}>to</span>
//     <Input 
//     type="date" 
//     className={styles.compactInput} 
//     value={pubEndDate}
//     onChange={(e, data) => setPubEndDate(data.value)}
//     />
//    </div>
//    </div>
//    </div>
//    )}

//    {filterVisibility.lastRecordUpdate && (
//    <div className={styles.formRow}>
//    <div className={styles.rowLabel}>Last Record Update</div>
//    <div className={styles.rowInputArea}>
//    <div className={styles.dateRangeContainer}>
//     <Input 
//     type="date" 
//     className={styles.compactInput} 
//     value={lastRecordUpdateStart}
//     onChange={(e, data) => setLastRecordUpdateStart(data.value)}
//     />
//     <span className={styles.dateText}>to</span>
//     <Input 
//     type="date" 
//     className={styles.compactInput} 
//     value={lastRecordUpdateEnd}
//     onChange={(e, data) => setLastRecordUpdateEnd(data.value)}
//     />
//    </div>
//    </div>
//    </div>
//    )}

//    {filterVisibility.sourceTitle && (
//    <div className={styles.formRow}>
//    <div className={styles.rowLabel}>Source Title</div>
//    <div className={styles.rowInputArea}>
//    <Input 
//     className={styles.compactInput} 
//     placeholder="Type here...eg. Nature Genetics" 
//     value={sourceTitle}
//     onChange={(e, data) => setSourceTitle(data.value)}
//    />
//    </div>
//    </div>
//    )}

//    {filterVisibility.issn && (
//    <div className={styles.formRow}>
//    <div className={styles.rowLabel}>ISSN</div>
//    <div className={styles.rowInputArea}>
//    <Input 
//     className={styles.compactInput} 
//     placeholder="e.g. 1234-5678" 
//     value={issn}
//     onChange={(e, data) => setIssn(data.value)}
//    />
//    </div>
//    </div>
//    )}

//    {filterVisibility.dataProvider && (
//    <div className={styles.formRow}>
//    <div className={styles.rowLabel}>Data Provider</div>
//    <div className={styles.rowInputArea}>
//    <Input 
//     className={styles.compactInput} 
//     placeholder="Type here...eg. Ovid (ASCO), etc" 
//     value={dataProvider}
//     onChange={(e, data) => setDataProvider(data.value)}
//    />
//    </div>
//    </div>
//    )}

//    {filterVisibility.volume && (
//    <div className={styles.formRow}>
//    <div className={styles.rowLabel}>Volume</div>
//    <div className={styles.rowInputArea}>
//    <Input 
//     className={styles.compactInput} 
//     placeholder="Volume string..." 
//     value={volume}
//     onChange={(e, data) => setVolume(data.value)}
//    />
//    </div>
//    </div>
//    )}

//    {filterVisibility.issue && (
//    <div className={styles.formRow}>
//    <div className={styles.rowLabel}>Issue</div>
//    <div className={styles.rowInputArea}>
//    <Input 
//     className={styles.compactInput} 
//     placeholder="Issue string..." 
//     value={issue}
//     onChange={(e, data) => setIssue(data.value)}
//    />
//    </div>
//    </div>
//    )}

//    {filterVisibility.limit && (
//    <div className={styles.formRow}>
//    <div className={styles.rowLabel}>Fetch Limit</div>
//    <div className={styles.rowInputArea}>
//    <Input 
//     type="number"
//     min={1}
//     max={20}
//     className={styles.compactInput} 
//     placeholder="Max 20 items" 
//     value={limit}
//     onChange={(e, data) => {
//     if (Number(data.value) > 20) setLimit("20");
//     else setLimit(data.value);
//     }}
//    />
//    </div>
//    </div>
//    )}

//    {filterVisibility.rights && (
//    <>
//    <div className={styles.collapsibleHeader} onClick={toggleRights}>
//    <span>Granted Rights</span>
//    {isRightsExpanded ? <ChevronUp20Regular /> : <ChevronDown20Regular />}
//    </div>
    
//    {isRightsExpanded && (
//    <div className={styles.rightsGrid}>
//     <Checkbox 
//     className={styles.checkboxLabel} 
//     shape="circular" 
//     label="Perpetual Access" 
//     checked={rights.perpetualAccess}
//     onChange={(e, data) => handleRightChange('perpetualAccess', data.checked)}
//     />
//     <Checkbox 
//     className={styles.checkboxLabel} 
//     shape="circular" 
//     label="AI Training" 
//     checked={rights.aiTraining}
//     onChange={(e, data) => handleRightChange('aiTraining', data.checked)}
//     />
//     <Checkbox 
//     className={styles.checkboxLabel} 
//     shape="circular" 
//     label="AI Inference" 
//     checked={rights.aiInference}
//     onChange={(e, data) => handleRightChange('aiInference', data.checked)}
//     />
//     <Checkbox 
//     className={styles.checkboxLabel} 
//     shape="circular" 
//     label="AI Medinfo" 
//     checked={rights.aiMedinfo}
//     onChange={(e, data) => handleRightChange('aiMedinfo', data.checked)}
//     />
//    </div>
//    )}
//    </>
//    )}

//    {filterVisibility.createdAt && (
//    <div className={styles.formRow}>
//    <div className={styles.rowLabel}>Created At</div>
//    <div className={styles.rowInputArea}>
//    <div className={styles.dateRangeContainer}>
//     <Input 
//     type="date" 
//     className={styles.compactInput} 
//     value={createdStartDate}
//     onChange={(e, data) => setCreatedStartDate(data.value)}
//     />
//     <span className={styles.dateText}>to</span>
//     <Input 
//     type="date" 
//     className={styles.compactInput} 
//     value={createdEndDate}
//     onChange={(e, data) => setCreatedEndDate(data.value)}
//     />
//    </div>
//    </div>
//    </div>
//    )}

//   </div>
//   </div>
   
//   {/* 3. PINNED BOTTOM ACTIONS */}
//   <div className={styles.actionFooter}>
//   <Button className={styles.outlineBtn} onClick={handleReset}>
//    Reset fields
//   </Button>
//   <Button className={styles.outlineBtn} onClick={handleApply}>
//    Apply filters
//   </Button>
//   </div>
//   </>
//   )}

//   {/* ----------------- TAB 2: DOI ----------------- */}
//   {activeTab === 'doi' && (
//   <div>
//   <div className={styles.searchRow}>
//   <Input 
//    className={styles.searchInput}
//    placeholder="e.g. 10.1016/j.puhe.2021.01.009, 10.9745/GHSP-D..." 
//    value={doiSearch}
//    onChange={(e, data) => setDoiSearch(data.value)}
//   />
//   <Button 
//    className={styles.searchBtn} 
//    onClick={handleApply}
//    disabled={isDoiLimitExceeded} 
//   >
//    Search DOI
//   </Button>
//   </div>
   
//   {isDoiLimitExceeded && (
//    <div className={styles.doiErrorText}>
//     ⚠️ You cannot add more than 20 DOIs. Please remove {excessDoiCount} DOI{excessDoiCount > 1 ? 's' : ''}.
//    </div>
//   )}

//   <div style={{ padding: '20px', textAlign: 'center', color: '#666', fontSize: '12px' }}>
//   Paste a single DOI or multiple DOIs separated by commas to instantly lookup articles. (Max limit: 20)
//   </div>
//   </div>
//   )}
//  </div>
//  )}

//  {/* ----------------- FILTER SELECTION MODAL ----------------- */}
//  <Dialog 
//  open={isFilterModalOpen} 
//  onOpenChange={(event, data) => !data.open && setIsFilterModalOpen(false)}
//  >
//  <DialogSurface className={styles.dialogSurface}>
//   <DialogBody>
//   <DialogTitle>Select Visible Filters</DialogTitle>
//   <DialogContent>
//   <div style={{ fontSize: '13px', color: '#605e5c', marginBottom: '8px' }}>
//   Choose which filter fields you want to see below.
//   </div>
//   <div className={styles.dialogCheckboxList}>
//   <Checkbox 
//    label="Full Text Search" 
//    checked={tempVisibility.fullText} 
//    onChange={(e, data) => setTempVisibility({...tempVisibility, fullText: data.checked})}
//   />
//   <Checkbox 
//    label="Publication Date" 
//    checked={tempVisibility.pubDate} 
//    onChange={(e, data) => setTempVisibility({...tempVisibility, pubDate: data.checked})}
//   />
//   <Checkbox 
//    label="Source Title" 
//    checked={tempVisibility.sourceTitle} 
//    onChange={(e, data) => setTempVisibility({...tempVisibility, sourceTitle: data.checked})}
//   />
//   <Checkbox 
//    label="Data Provider" 
//    checked={tempVisibility.dataProvider} 
//    onChange={(e, data) => setTempVisibility({...tempVisibility, dataProvider: data.checked})}
//   />
//   <Checkbox 
//    label="Granted Rights" 
//    checked={tempVisibility.rights} 
//    onChange={(e, data) => setTempVisibility({...tempVisibility, rights: data.checked})}
//   />
//   <Checkbox 
//    label="Created At" 
//    checked={tempVisibility.createdAt} 
//    onChange={(e, data) => setTempVisibility({...tempVisibility, createdAt: data.checked})}
//   />
   
//   <Checkbox 
//    label="Last Record Update" 
//    checked={tempVisibility.lastRecordUpdate} 
//    onChange={(e, data) => setTempVisibility({...tempVisibility, lastRecordUpdate: data.checked})}
//   />
//   <Checkbox 
//    label="ISSN" 
//    checked={tempVisibility.issn} 
//    onChange={(e, data) => setTempVisibility({...tempVisibility, issn: data.checked})}
//   />
//   <Checkbox 
//    label="Volume" 
//    checked={tempVisibility.volume} 
//    onChange={(e, data) => setTempVisibility({...tempVisibility, volume: data.checked})}
//   />
//   <Checkbox 
//    label="Issue" 
//    checked={tempVisibility.issue} 
//    onChange={(e, data) => setTempVisibility({...tempVisibility, issue: data.checked})}
//   />
//   <Checkbox 
//    label="Fetch Limit" 
//    checked={tempVisibility.limit} 
//    onChange={(e, data) => setTempVisibility({...tempVisibility, limit: data.checked})}
//   />
//   </div>
//   </DialogContent>
//   <DialogActions style={{ marginTop: '16px' }}>
//   <Button appearance="secondary" onClick={() => setIsFilterModalOpen(false)}>Cancel</Button>
//   <Button appearance="primary" onClick={saveFilterVisibility}>Done</Button>
//   </DialogActions>
//   </DialogBody>
//  </DialogSurface>
//  </Dialog>

//  </div>
//  );
// };

// RomineFilter.propTypes = {
//  onApply: PropTypes.func.isRequired,
// };

// export default RomineFilter;




// Symentic  SEARCH UI FULL CHANGE TO ONLY 1 TAB WITH SUB TAB 2



// import React, { useState } from 'react';
// import PropTypes from 'prop-types';
// import { 
//  Button, 
//  Input, 
//  makeStyles, 
//  mergeClasses,
//  Tooltip,
//  Switch 
// } from '@fluentui/react-components';
// import { ChevronDown20Regular, ChevronUp20Regular } from '@fluentui/react-icons';

// const useStyles = makeStyles({
//  container: {
//  padding: '4px 10px',
//  backgroundColor: '#f8f9fa',
//  borderBottom: '1px solid #e0e0e0',
//  },
//  headerWrapper: {
//  display: 'flex',
//  justifyContent: 'space-between',
//  alignItems: 'center',
//  cursor: 'pointer',
//  color: '#022366',
//  fontStyle: 'italic',
//  fontSize: '13px',
//  padding: '4px 0',
//  },
//  headerLeft: {
//  display: 'flex',
//  alignItems: 'center',
//  gap: '8px',
//  },
//  panel: {
//  marginTop: '8px',
//  backgroundColor: '#fff',
//  border: '1px solid #e0e0e0',
//  borderRadius: '4px',
//  overflow: 'hidden',
//  boxShadow: '0 2px 4px rgba(0,0,0,0.05)',
//  display: 'flex',
//  flexDirection: 'column',
//  },
//  // Primary tabs container style
//  tabsContainer: {
//  display: 'flex',
//  borderBottom: '1px solid #022366',
//  backgroundColor: '#f0f0f0',
//  flexShrink: 0,
//  },
//  tab: {
//  padding: '8px 12px',
//  cursor: 'pointer',
//  fontSize: '11px',
//  fontWeight: '600',
//  color: '#333',
//  flex: 1,
//  textAlign: 'center',
//  borderRight: '1px solid #ccc',
//  transition: 'background-color 0.2s',
//  whiteSpace: 'nowrap',
//  overflow: 'hidden',
//  textOverflow: 'ellipsis'
//  },
//  activeTab: {
//  backgroundColor: '#022366',
//  color: '#ffffff',
//  },
//  // Sub-tabs specific styling for modern nesting contrast
//  subTabsContainer: {
//  display: 'flex',
//  borderBottom: '1px solid #e0e0e0',
//  backgroundColor: '#faf9f8',
//  flexShrink: 0,
//  },
//  subTab: {
//  padding: '8px 12px',
//  cursor: 'pointer',
//  fontSize: '11px',
//  fontWeight: '600',
//  color: '#605e5c',
//  flex: 1,
//  textAlign: 'center',
//  borderRight: '1px solid #edebe9',
//  borderBottom: '2px solid transparent',
//  transition: 'all 0.2s ease',
//  whiteSpace: 'nowrap',
//  overflow: 'hidden',
//  textOverflow: 'ellipsis',
//  ':hover': {
//  backgroundColor: '#f3f2f1',
//  }
//  },
// activeSubTab: {
//   backgroundColor: '#022366', // Deep active blue background
//   color: '#ffffff',           // White text color
//   borderBottom: '2px solid #022366',
//   ':hover': {
//     backgroundColor: '#011640', // Subtle darker blue when hovered while active
//     color: '#ffffff',
//   }
// },
//  // Full Text Search / Query Rows
//  searchRow: {
//  display: 'flex',
//  alignItems: 'center',
//  padding: '10px',
//  gap: '8px',
//  backgroundColor: '#f5f5f5',
//  borderBottom: '1px solid #d1d1d1',
//  flexShrink: 0,
//  },
//  searchInput: {
//  flexGrow: 1,
//  backgroundColor: '#ffffff',
//  'input': { fontSize: '12px' }
//  },
//  searchBtn: {
//  backgroundColor: '#022366',
//  color: '#ffffff',
//  fontWeight: '600',
//  fontSize: '12px',
//  padding: '4px 12px',
//  minWidth: 'auto',
//  ':hover': {
//  backgroundColor: '#011640',
//  color: '#ffffff',
//  }
//  },
//  // Form Grid Styles
//  formGrid: {
//  display: 'flex',
//  flexDirection: 'column',
//  },
//  formRow: {
//  display: 'flex',
//  borderBottom: '1px solid #e0e0e0',
//  minHeight: '34px',
//  },
//  rowLabel: {
//  width: '125px', 
//  backgroundColor: '#f3f2f1',
//  padding: '6px 8px',
//  display: 'flex',
//  alignItems: 'center',
//  fontSize: '11px',
//  color: '#323130',
//  borderRight: '1px solid #e0e0e0',
//  flexShrink: 0,
//  },
//  rowInputArea: {
//  flex: 1,
//  padding: '4px 8px',
//  display: 'flex',
//  alignItems: 'center',
//  gap: '8px',
//  },
//  dateRangeContainer: {
//  display: 'flex',
//  alignItems: 'center',
//  flexWrap: 'wrap',
//  gap: '4px',
//  width: '100%',
//  },
//  dateText: {
//  fontSize: '11px',
//  color: '#605e5c',
//  padding: '0 2px'
//  },
//  compactInput: {
//  flex: 1,
//  minWidth: '100px', 
//  '& input': {
//  fontSize: '11px',
//  padding: '4px 6px'
//  }
//  },
//  // Bottom Actions
//  actionFooter: {
//  display: 'flex',
//  justifyContent: 'flex-end',
//  padding: '10px 12px',
//  gap: '10px',
//  backgroundColor: '#ffffff',
//  borderTop: '1px solid #e0e0e0', 
//  flexShrink: 0,
//  },
//  outlineBtn: {
//  color: '#022366',
//  backgroundColor: '#ffffff',
//  border: '1px solid #022366',
//  fontSize: '12px',
//  padding: '4px 12px',
//  minWidth: 'auto',
//  ':hover': {
//  backgroundColor: '#f3f2f1',
//  color: '#022366',
//  }
//  },
//  doiErrorText: {
//  color: '#d13438',
//  fontSize: '11px',
//  padding: '4px 10px',
//  backgroundColor: '#fde7e9',
//  borderBottom: '1px solid #d1d1d1'
//  }
// });

// const RomineFilter = ({ onApply }) => {
//  const styles = useStyles();
//  const [isExpanded, setIsExpanded] = useState(false);
//  const [activeTab, setActiveTab] = useState('semantic'); // 'semantic' = Filters, 'doi' = DOI search

//  // --- Form Data States ---
//  const [semanticSearch, setSemanticSearch] = useState('');
//  const [semanticDataProvider, setSemanticDataProvider] = useState('');
//  const [semanticJournal, setSemanticJournal] = useState(''); 
//  const [semanticInclude, setSemanticInclude] = useState(false);
//  const [semanticPubStartDate, setSemanticPubStartDate] = useState(''); // Added publication start date
//  const [semanticPubEndDate, setSemanticPubEndDate] = useState(''); // Added publication end date
//  const [semanticLimit, setSemanticLimit] = useState(''); // Added fetch limit
//  const [semanticIncludeFullText, setSemanticIncludeFullText] = useState(false); // Added full text toggle
//  const [doiSearch, setDoiSearch] = useState('');
//      const [doiIncludeFullText, setDoiIncludeFullText] = useState(false);

//  const toggleExpand = () => setIsExpanded(!isExpanded);

//  const handleReset = () => {
//  setSemanticSearch('');
//  setSemanticDataProvider('');
//  setSemanticJournal(''); 
//  setSemanticInclude(false);
//  setSemanticPubStartDate('');
//  setSemanticPubEndDate('');
//  setSemanticLimit('');
//  setSemanticIncludeFullText(false);
//  setDoiSearch('');
//      setDoiIncludeFullText(false);
//  };

//  // Calculate current DOI count by splitting by commas and ignoring empty spaces
//  const currentDoiCount = doiSearch.split(',').map(d => d.trim()).filter(d => d.length > 0).length;
//  const isDoiLimitExceeded = currentDoiCount > 20;
//  const excessDoiCount = currentDoiCount - 20;

//  const handleApply = () => {
//  if (!onApply) return;

//   if (activeTab === 'semantic') {
//   onApply({
//    filterType: 'semantic_text_search',
//    query: semanticSearch,
//    filters: {
//     dataProvider: semanticDataProvider,
//     journal: semanticJournal,
//     // include_full_text: semanticInclude ? "True" : "False", 
//        include_full_text: semanticIncludeFullText ? "True" : "False",
//     limit: semanticLimit ? String(semanticLimit) : null, 
//     pubStartDate: semanticPubStartDate,
//     pubEndDate: semanticPubEndDate
//    }
//   });
//  } else {
//   // Prevent submission if DOI limit is exceeded (fallback security)
//   if (isDoiLimitExceeded) return; 

//   onApply({
//    filterType: 'semantic_doi_search',
//    query: doiSearch,
//     filters: {
//         include_full_text: doiIncludeFullText ? "True" : "False" 
//     }
//   });
//  }
  
//  setIsExpanded(false); 
//  };

//  return (
//  <div className={styles.container}>
//  <div className={styles.headerWrapper} onClick={toggleExpand}>
//  <div className={styles.headerLeft}>
//  <span>Choose and apply filters</span>
//  </div>
//  {isExpanded ? <ChevronUp20Regular /> : <ChevronDown20Regular />}
//  </div>

//  {isExpanded && (
//  <div className={styles.panel}>
  
//  {/* Primary Parent Tab: Shows Only Semantic Search */}
//  {/* <div className={styles.tabsContainer}>
//  <div className={mergeClasses(styles.tab, styles.activeTab)} style={{ cursor: 'default' }}>
//   Semantic Search
//  </div>
//  </div> */}

//  {/* Secondary Sub-Tabs Container */}
//  <div className={styles.subTabsContainer}>
//  <div 
//   className={mergeClasses(styles.subTab, activeTab === 'semantic' && styles.activeSubTab)}
//   onClick={() => setActiveTab('semantic')}
//  >
//   Search with Filters
//  </div>
//  <div 
//   className={mergeClasses(styles.subTab, activeTab === 'doi' && styles.activeSubTab)}
//   onClick={() => setActiveTab('doi')}
//  >
//   DOI Search
//  </div>
//  </div>

//  {/* ----------------- SUB-TAB 1: SEMANTIC SEARCH WITH FILTERS ----------------- */}
//  {activeTab === 'semantic' && (
//  <>
//   {/* QUERY BOX */}
//   <div className={styles.searchRow}>
//   <Input 
//   className={styles.searchInput}
//   placeholder="Type semantic search query here..." 
//   value={semanticSearch}
//   onChange={(e, data) => setSemanticSearch(data.value)}
//   />
//   <Button className={styles.searchBtn} onClick={handleApply}>
//   Search
//   </Button>
//   </div>

//   {/* SEMANTIC SEARCH FILTERS */}
//   <div style={{ backgroundColor: '#ffffff' }}>
//   <div className={styles.formGrid}>

//   {/* Data Provider Field */}
//   <div className={styles.formRow}>
//    <div className={styles.rowLabel}>Data Provider</div>
//    <div className={styles.rowInputArea}>
//    <Input 
//    className={styles.compactInput} 
//    placeholder="Type here...eg. Ovid (ASCO), etc" 
//    value={semanticDataProvider}
//    onChange={(e, data) => setSemanticDataProvider(data.value)}
//    />
//    </div>
//   </div>
   
//   {/* Journal Field with Tooltip */}
//   <div className={styles.formRow}>
//   <div className={styles.rowLabel}>Journal</div>
//   <div className={styles.rowInputArea}>
//   <Tooltip 
//    content={
//    <div style={{ padding: '4px', maxWidth: '280px', fontSize: '11px', lineHeight: '1.4' }}>
//    <strong>Exact Match:</strong> Type exact journal name (e.g., <em>Diagnostics</em>)<br />
//    <strong>Substring Match:</strong> Prefix with <strong>~</strong> (e.g., <em>~nature</em> matches "Nature", "Nature Genetics", etc.)<br />
//    <em>* Case-insensitive</em>
//    </div>
//    }
//    relationship="description"
//   >
//    <Input 
//    className={styles.compactInput} 
//    placeholder='e.g., Diagnostics, ~nature, ~lancet, ~nat' 
//    value={semanticJournal}
//    onChange={(e, data) => setSemanticJournal(data.value)}
//    />
//   </Tooltip>
//   </div>
//   </div>

//   {/* Publication Date Range Field */}
//   {/* <div className={styles.formRow}>
//   <div className={styles.rowLabel}>Publication Date</div>
//   <div className={styles.rowInputArea}>
//    <div className={styles.dateRangeContainer}>
//    <Input 
//     type="date" 
//     className={styles.compactInput} 
//     value={semanticPubStartDate}
//     onChange={(e, data) => setSemanticPubStartDate(data.value)}
//    />
//    <span className={styles.dateText}>to</span>
//    <Input 
//     type="date" 
//     className={styles.compactInput} 
//     value={semanticPubEndDate}
//     onChange={(e, data) => setSemanticPubEndDate(data.value)}
//    />
//    </div>
//   </div>
//   </div> */}

//   {/* Fetch Limit Field */}
//   <div className={styles.formRow}>
//    <div className={styles.rowLabel}>Fetch Limit</div>
//    <div className={styles.rowInputArea}>
//    <Input 
//     type="number"
//     min="1"
//     max="20"
//     className={styles.compactInput} 
//     placeholder="e.g. 5" 
//     value={semanticLimit}
//     onChange={(e, data) => setSemanticLimit(data.value)}
//    />
//    </div>
//   </div>

//   {/* Include Full Text Field (Toggle Button) */}
//   <div className={styles.formRow}>
//    <div className={styles.rowLabel}>Include Full Text</div>
//    <div className={styles.rowInputArea}>
//    <Switch
//     checked={semanticIncludeFullText}
//     onChange={(e, data) => setSemanticIncludeFullText(data.checked)}
//    />
//    </div>
//   </div>

//   </div>
//   </div>
   
//   {/* RESET BUTTONS */}
//   <div className={styles.actionFooter}>
//   <Button className={styles.outlineBtn} onClick={handleReset}>
//   Reset fields
//   </Button>
//   <Button className={styles.outlineBtn} onClick={handleApply}>
//   Apply filters
//   </Button>
//   </div>
//  </>
//  )}

//  {/* ----------------- SUB-TAB 2: SEMANTIC DOI SEARCH ----------------- */}
//  {activeTab === 'doi' && (
//  <div>
//   <div className={styles.searchRow}>
//   <Input 
//   className={styles.searchInput}
//   placeholder="e.g. 10.1016/j.puhe.2021.01.009, 10.9745/GHSP-D..." 
//   value={doiSearch}
//   onChange={(e, data) => setDoiSearch(data.value)}
//   />
//   <Button 
//   className={styles.searchBtn} 
//   onClick={handleApply}
//   disabled={isDoiLimitExceeded} 
//   >
//   Search DOI
//   </Button>
//   </div>
   
//   {isDoiLimitExceeded && (
//   <div className={styles.doiErrorText}>
//   ⚠️ You cannot add more than 20 DOIs. Please remove {} DOI{excessDoiCount > 1 ? 's' : ''}.
//   </div>
//   )}

//      <div style={{ backgroundColor: '#ffffff' }}>
//     <div className={styles.formGrid}>
//      <div className={styles.formRow}>
//       <div className={styles.rowLabel}>Include Content</div>
//       <div className={styles.rowInputArea}>
//        <Switch
//         checked={doiIncludeFullText}
//         onChange={(e, data) => setDoiIncludeFullText(data.checked)}
//        />
//       </div>
//      </div>
//     </div>
//    </div>

//   <div style={{ padding: '20px', textAlign: 'center', color: '#666', fontSize: '12px' }}>
//   Enter a single DOI to instantly lookup the article.
//   </div>
//      {/* <div style={{ padding: '20px', textAlign: 'center', color: '#666', fontSize: '12px' }}>
//           Paste a single DOI or multiple DOIs separated by commas to instantly lookup articles. (Max limit: 20)
//           </div> */}
//  </div>
//  )}
//  </div>
//  )}
//  </div>
//  );
// };

// RomineFilter.propTypes = {
//  onApply: PropTypes.func.isRequired,
// };

// export default RomineFilter;





import React, { useState } from 'react';
import PropTypes from 'prop-types';
import {
 Button,
 Input,
 makeStyles,
 mergeClasses,
 Tooltip,
 Switch
} from '@fluentui/react-components';
import { ChevronDown20Regular, ChevronUp20Regular } from '@fluentui/react-icons';

const useStyles = makeStyles({
 container: {
  padding: '4px 10px',
  backgroundColor: '#f8f9fa',
  borderBottom: '1px solid #e0e0e0',
 },
 headerWrapper: {
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  cursor: 'pointer',
  color: '#022366',
  fontStyle: 'italic',
  fontSize: '13px',
  padding: '4px 0',
 },
 headerLeft: {
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
 },
 panel: {
  marginTop: '8px',
  backgroundColor: '#fff',
  border: '1px solid #e0e0e0',
  borderRadius: '4px',
  overflow: 'hidden',
  boxShadow: '0 2px 4px rgba(0,0,0,0.05)',
  display: 'flex',
  flexDirection: 'column',
 },
 tabsContainer: {
  display: 'flex',
  borderBottom: '1px solid #022366',
  backgroundColor: '#f0f0f0',
  flexShrink: 0,
 },
 tab: {
  padding: '8px 12px',
  cursor: 'pointer',
  fontSize: '11px',
  fontWeight: '600',
  color: '#333',
  flex: 1,
  textAlign: 'center',
  borderRight: '1px solid #ccc',
  transition: 'background-color 0.2s',
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis'
 },
 activeTab: {
  backgroundColor: '#022366',
  color: '#ffffff',
 },
 subTabsContainer: {
  display: 'flex',
  borderBottom: '1px solid #e0e0e0',
  backgroundColor: '#faf9f8',
  flexShrink: 0,
 },
 subTab: {
  padding: '8px 12px',
  cursor: 'pointer',
  fontSize: '11px',
  fontWeight: '600',
  color: '#605e5c',
  flex: 1,
  textAlign: 'center',
  borderRight: '1px solid #edebe9',
  borderBottom: '2px solid transparent',
  transition: 'all 0.2s ease',
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  ':hover': {
   backgroundColor: '#f3f2f1',
  }
 },
 activeSubTab: {
  backgroundColor: '#022366',
  color: '#ffffff',
  borderBottom: '2px solid #022366',
  ':hover': {
   backgroundColor: '#011640',
   color: '#ffffff',
  }
 },
 /* --- CHANGED: searchRow layout changed to column --- */
 searchRow: {
  display: 'flex',
  flexDirection: 'column', 
  padding: '10px',
  gap: '4px', // Small gap between the input row and the error text below it
  backgroundColor: '#f5f5f5',
  borderBottom: '1px solid #d1d1d1',
  flexShrink: 0,
 },
 /* --- NEW: Sub-wrapper to keep input & search button aligned horizontally --- */
 inputGroup: {
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
  width: '100%',
 },
 searchInput: {
  width: '100%',
  backgroundColor: '#ffffff',
  'input': { fontSize: '12px' }
 },
 searchBtn: {
  backgroundColor: '#022366',
  color: '#ffffff',
  fontWeight: '600',
  fontSize: '12px',
  padding: '4px 12px',
  minWidth: 'auto',
  ':hover': {
   backgroundColor: '#011640',
   color: '#ffffff',
  }
 },
 formGrid: {
  display: 'flex',
  flexDirection: 'column',
 },
 formRow: {
  display: 'flex',
  borderBottom: '1px solid #e0e0e0',
  minHeight: '34px',
 },
 rowLabel: {
  width: '125px',
  backgroundColor: '#f3f2f1',
  padding: '6px 8px',
  display: 'flex',
  alignItems: 'center',
  fontSize: '11px',
  color: '#323130',
  borderRight: '1px solid #e0e0e0',
  flexShrink: 0,
 },
 rowInputArea: {
  flex: 1,
  padding: '4px 8px',
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
 },
 verticalInputArea: {
  flex: 1,
  padding: '6px 8px',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'stretch',
  justifyContent: 'center',
  gap: '2px',
 },
 dateRangeContainer: {
  display: 'flex',
  alignItems: 'center',
  flexWrap: 'wrap',
  gap: '4px',
  width: '100%',
 },
 dateText: {
  fontSize: '11px',
  color: '#605e5c',
  padding: '0 2px'
 },
 compactInput: {
  flex: 1,
  minWidth: '100px',
  '& input': {
   fontSize: '11px',
   padding: '4px 6px'
  }
 },
 actionFooter: {
  display: 'flex',
  justifyContent: 'flex-end',
  padding: '10px 12px',
  gap: '10px',
  backgroundColor: '#ffffff',
  borderTop: '1px solid #e0e0e0',
  flexShrink: 0,
 },
 outlineBtn: {
  color: '#022366',
  backgroundColor: '#ffffff',
  border: '1px solid #022366',
  fontSize: '12px',
  padding: '4px 12px',
  minWidth: 'auto',
  ':hover': {
   backgroundColor: '#f3f2f1',
   color: '#022366',
  }
 },
 doiErrorText: {
  color: '#d13438',
  fontSize: '11px',
  padding: '4px 10px',
  backgroundColor: '#fde7e9',
  borderBottom: '1px solid #d1d1d1'
 },
 semanticErrorText: {
  color: '#d13438',
  fontSize: '11px',
  paddingTop: '4px',
  display: 'block',
 }
});

// 🟢 INSERT THIS VALIDATION HELPER DIRECTLY ABOVE RomineFilter DEFINITION
const validateDois = (inputValue) => {
 if (!inputValue.trim()) {
  return "The DOI search query cannot be empty. Please enter a DOI to proceed.";
 }
 const items = inputValue.split(',').map(item => item.trim()).filter(Boolean);
 for (let item of items) {
  // Strip common URL prefixes to extract the raw DOI prefix
  const clean = item.replace(/^(https?:\/\/(dx\.)?doi\.org\/|doi:)/i, "");
  // DOIs strictly begin with prefix "10."
  if (!/^10\./.test(clean)) {
   return `Invalid entry: "${item}". Please enter only valid DOIs starting with "10." (e.g., 10.1016/...)`;
  }
 }
 return ""; // No error found
};

const RomineFilter = ({ onApply }) => {
 const styles = useStyles();
 const [isExpanded, setIsExpanded] = useState(false);
 const [activeTab, setActiveTab] = useState('semantic');
 const [semanticSearchError, setSemanticSearchError] = useState('');

 // --- Form Data States ---
 const [semanticSearch, setSemanticSearch] = useState('');
 const [semanticDataProvider, setSemanticDataProvider] = useState('');
 const [semanticJournal, setSemanticJournal] = useState('');
 const [semanticDois, setSemanticDois] = useState('');
 const [semanticInclude, setSemanticInclude] = useState(false);
 const [semanticPubStartDate, setSemanticPubStartDate] = useState('');
 const [semanticPubEndDate, setSemanticPubEndDate] = useState('');
 const [semanticLimit, setSemanticLimit] = useState('');
 const [semanticIncludeFullText, setSemanticIncludeFullText] = useState(false);
 const [doiSearch, setDoiSearch] = useState('');
 const [doiIncludeFullText, setDoiIncludeFullText] = useState(false);
     const [doiSearchError, setDoiSearchError] = useState(''); 

 const toggleExpand = () => setIsExpanded(!isExpanded);

 const handleReset = () => {
  setSemanticSearch('');
  setSemanticDataProvider('');
  setSemanticJournal('');
  setSemanticDois(''); 
  setSemanticInclude(false);
  setSemanticPubStartDate('');
  setSemanticPubEndDate('');
  setSemanticLimit('');
  setSemanticIncludeFullText(false);
  setDoiSearch('');
  setDoiIncludeFullText(false);
  setSemanticSearchError('');
     setDoiSearchError('');
 };

 const currentDoiCount = doiSearch.split(',').map(d => d.trim()).filter(d => d.length > 0).length;
 const isDoiLimitExceeded = currentDoiCount > 20;
 const excessDoiCount = currentDoiCount - 20;

 const handleApply = () => {
  if (!onApply) return;

  if (activeTab === 'semantic') {
   if (!semanticSearch.trim()) {
    setSemanticSearchError('The search query cannot be empty. Please enter a query to proceed.');
    return;
   }

   onApply({
    filterType: 'semantic_text_search',
    query: semanticSearch,
    filters: {
     dataProvider: semanticDataProvider,
     journal: semanticJournal,
     dois: semanticDois,
     include_full_text: semanticIncludeFullText ? "True" : "False",
     limit: semanticLimit ? String(semanticLimit) : null,
     pubStartDate: semanticPubStartDate,
     pubEndDate: semanticPubEndDate
    }
   });
  } else {
   if (isDoiLimitExceeded) return;

   // 🟢 INSERT THIS VALIDATION CHECK HERE:
   const validationMsg = validateDois(doiSearch);
   if (validationMsg) {
    setDoiSearchError(validationMsg);
    return; // Prevent form submission
   }

   onApply({
    filterType: 'semantic_doi_search',
    query: doiSearch,
    filters: {
     include_full_text: doiIncludeFullText ? "True" : "False"
    }
   });
  }

  setIsExpanded(false);
 };

 return (
  <div className={styles.container}>
   <div className={styles.headerWrapper} onClick={toggleExpand}>
    <div className={styles.headerLeft}>
     <span>Choose and apply filters</span>
    </div>
    {isExpanded ? <ChevronUp20Regular /> : <ChevronDown20Regular />}
   </div>

   {isExpanded && (
    <div className={styles.panel}>
     <div className={styles.subTabsContainer}>
      <div
       className={mergeClasses(styles.subTab, activeTab === 'semantic' && styles.activeSubTab)}
       onClick={() => setActiveTab('semantic')}
      >
       Search with Filters
      </div>
      <div
       className={mergeClasses(styles.subTab, activeTab === 'doi' && styles.activeSubTab)}
       onClick={() => setActiveTab('doi')}
      >
       DOI Search
      </div>
     </div>

     {activeTab === 'semantic' && (
      <>
       {/* --- UPDATED STRUCTURAL GRID FOR INPUT + SEARCH BUTTON + ERROR TEXT --- */}
       <div className={styles.searchRow}>
        <div className={styles.inputGroup}>
         <div style={{ flexGrow: 1 }}>
          <Input
           className={styles.searchInput}
           placeholder="Type semantic search query here..."
           value={semanticSearch}
           onChange={(e, data) => {
            setSemanticSearch(data.value);
            if (semanticSearchError) {
             setSemanticSearchError('');
            }
           }}
          />
         </div>
         <Button className={styles.searchBtn} onClick={handleApply}>
          Search
         </Button>
        </div>
        {/* Error message resides underneath, leaving the Search button vertically unaffected */}
        {semanticSearchError && <span className={styles.semanticErrorText}>{semanticSearchError}</span>}
       </div>

       <div style={{ backgroundColor: '#ffffff' }}>
        <div className={styles.formGrid}>
          <div className={styles.formRow}>
            <div className={styles.rowLabel}>Data Provider</div>
            <div className={styles.rowInputArea}>
              <Input
                className={styles.compactInput}
                placeholder="Type here...eg. Ovid (ASCO), etc"
                value={semanticDataProvider}
                onChange={(e, data) => setSemanticDataProvider(data.value)}
              />
            </div>
          </div>
          <div className={styles.formRow}>
            <div className={styles.rowLabel}>Journal</div>
            <div className={styles.rowInputArea}>
              <Tooltip
                content={
                  <div style={{ padding: '4px', maxWidth: '280px', fontSize: '11px', lineHeight: '1.4' }}>
                    <strong>Exact Match:</strong> Type exact journal name (e.g., <em>Diagnostics</em>)<br />
                    <strong>Substring Match:</strong> Prefix with <strong>~</strong> (e.g., <em>~nature</em> matches "Nature", "Nature Genetics", etc.)<br />
                    <em>* Case-insensitive</em>
                  </div>
                }
                relationship="description"
               >
    
                <Input
                  className={styles.compactInput}
                  placeholder='e.g., Diagnostics, ~nature, ~lancet, ~nat'
                  value={semanticJournal}
                  onChange={(e, data) => setSemanticJournal(data.value)}
                />
              </Tooltip>
            </div>
          </div>

          {/* THIS DOIs ROW STARTED HERE: */}
          <div className={styles.formRow} style={{ minHeight: '52px' }}>
            <div className={styles.rowLabel}>DOIs</div>
            <div className={styles.verticalInputArea}>
              <Input
                className={styles.compactInput}
                placeholder="e.g. 10.1016/j.puhe.2021.01.009, 10.9745/GHSP-D..."
                value={semanticDois}
                onChange={(e, data) => setSemanticDois(data.value)}
              />
              <span style={{ fontSize: '10px', color: '#605e5c', display: 'block', paddingTop: '2px' }}>
                Enter single or multiple DOIs separated by commas.
              </span>
            </div>
          </div>
            
          <div className={styles.formRow}>
            <div className={styles.rowLabel}>Fetch Limit</div>
            <div className={styles.rowInputArea}>
              <Input
                type="number"
                min="1"
                max="20"
                className={styles.compactInput}
                placeholder="e.g. 5"
                value={semanticLimit}
                onChange={(e, data) => setSemanticLimit(data.value)}
              />
            </div>
          </div>
          <div className={styles.formRow}>
            <div className={styles.rowLabel}>Include Full Text</div>
            <div className={styles.rowInputArea}>
              <Switch
                checked={semanticIncludeFullText}
                onChange={(e, data) => setSemanticIncludeFullText(data.checked)}
              />
            </div>
          </div>
        </div>
       </div>

       <div className={styles.actionFooter}>
        <Button className={styles.outlineBtn} onClick={handleReset}>
         Reset fields
        </Button>
        <Button className={styles.outlineBtn} onClick={handleApply}>
         Apply filters
        </Button>
       </div>
      </>
     )}

     {activeTab === 'doi' && (
      // <div>
      //  <div className={styles.searchRow}>
      //   <div className={styles.inputGroup}>
      //    <Input
      //     className={styles.searchInput}
      //     placeholder="e.g. 10.1016/j.puhe.2021.01.009, 10.9745/GHSP-D..."
      //     value={doiSearch}
      //     onChange={(e, data) => setDoiSearch(data.value)}
      //    />
      //    <Button
      //     className={styles.searchBtn}
      //     onClick={handleApply}
      //     disabled={isDoiLimitExceeded}
      //    >
      //     Search DOI
      //    </Button>
      //   </div>
      //  </div>

      //  {isDoiLimitExceeded && (
      //   <div className={styles.doiErrorText}>
      //    ⚠️ You cannot add more than 20 DOIs. Please remove {excessDoiCount} DOI{excessDoiCount > 1 ? 's' : ''}.
      //   </div>
      //  )}

      //  <div style={{ backgroundColor: '#ffffff' }}>
      //   <div className={styles.formGrid}>
      //    <div className={styles.formRow}>
      //     <div className={styles.rowLabel}>Include Content</div>
      //     <div className={styles.rowInputArea}>
      //      <Switch
      //       checked={doiIncludeFullText}
      //       onChange={(e, data) => setDoiIncludeFullText(data.checked)}
      //      />
      //     </div>
      //    </div>
      //   </div>
      //  </div>

      //  <div style={{ padding: '20px', textAlign: 'center', color: '#666', fontSize: '12px' }}>
      //   Enter a single DOI to instantly lookup the article.
      //  </div>
      // </div>

      <div>
       {/* --- UPDATED: Split searchRow to match Search with Filters tab --- */}
       <div className={styles.searchRow}>
        <div className={styles.inputGroup}>
         <div style={{ flexGrow: 1 }}>
          <Input
           className={styles.searchInput}
           placeholder="e.g. 10.1016/j.puhe.2021.01.009, 10.9745/GHSP-D..."
           value={doiSearch}
           onChange={(e, data) => {
            setDoiSearch(data.value);
            if (doiSearchError) {
             setDoiSearchError(''); // Clear error dynamically when user types
            }
           }}
          />
         </div>
         <Button
          className={styles.searchBtn}
          onClick={handleApply}
          disabled={isDoiLimitExceeded}
         >
          Search DOI
         </Button>
        </div>
        {/* Render error cleanly underneath to keep button alignment locked */}
        {doiSearchError && <span className={styles.semanticErrorText}>{doiSearchError}</span>}
       </div>

       {isDoiLimitExceeded && (
        <div className={styles.doiErrorText}>
         ⚠️ You cannot add more than 20 DOIs. Please remove {excessDoiCount} DOI{excessDoiCount > 1 ? 's' : ''}.
        </div>
       )}

       <div style={{ backgroundColor: '#ffffff' }}>
        <div className={styles.formGrid}>
         <div className={styles.formRow}>
          <div className={styles.rowLabel}>Include Content</div>
          <div className={styles.rowInputArea}>
           <Switch
            checked={doiIncludeFullText}
            onChange={(e, data) => setDoiIncludeFullText(data.checked)}
           />
          </div>
         </div>
        </div>
       </div>

       {/* 🟢 UPDATED EXPLANATORY HELP TEXT */}
       <div style={{ padding: '20px', textAlign: 'center', color: '#666', fontSize: '11px', lineHeight: '1.5' }}>
        Enter single or multiple DOIs separated by commas.<br />
        <span style={{ color: '#d13438', fontWeight: '600' }}>Only standardized DOI strings are allowed in this search panel.</span>
       </div>
      </div>
     )}
    </div>
   )}
  </div>
 );
};

RomineFilter.propTypes = {
 onApply: PropTypes.func.isRequired,
};

export default RomineFilter;